import { useState } from 'react';

const useListHeader = (): { filtersVisible: boolean; handleFilterClick: () => void } => {
  const [filtersVisible, setFiltersVisible] = useState<boolean>(false);

  const handleFilterClick = (): void => {
    setFiltersVisible(!filtersVisible);
  };

  return {
    filtersVisible,
    handleFilterClick,
  };
};

export default useListHeader;
